import { getAuditTrailForEntity, searchAuditTrail } from '@/domains/settings/api/auditTrailApi';
import { queryKeys } from '@/lib/query-client';
import type { AuditEntityType, AuditTrailSearchQuery } from '@skewb-works/contracts';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

interface PaginationParams {
  limit?: number;
  skip?: number;
}

export function useAuditTrailForEntity(
  entityType: AuditEntityType,
  entityId: number,
  params: PaginationParams = {},
) {
  return useQuery({
    queryKey: [...queryKeys.auditTrail.entity(entityType, String(entityId)), params],
    queryFn: () => getAuditTrailForEntity(entityType, entityId, params),
    enabled: entityId > 0,
    staleTime: 0,
  });
}

export function useAuditTrailSearch(filters: Partial<AuditTrailSearchQuery>, enabled = true) {
  return useQuery({
    queryKey: queryKeys.auditTrail.search(filters),
    queryFn: () => searchAuditTrail(filters),
    placeholderData: keepPreviousData,
    enabled,
  });
}
